import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/GelleryPage/Banner'
import Footer from '../Component/NavBarFooter/Footer'
import { Helmet } from 'react-helmet'

function GelleryPage() {
  return (
    <div>
        <Helmet>
        <title>Nask Studio Gallery – Photo & Video Highlights</title>
        <meta name="description" content="Explore our gallery showcasing top photography and videography work from weddings, events, and studio shoots across Pakistan. See our creative style." />
      </Helmet>
        <NavBar/>
        <Banner/>
        <Footer/>
    </div>
  )
}

export default GelleryPage